/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React from "react";

/**
 * Field Wrapper to be used in forms
 * @param {*} param0 
 * @returns 
 */
export default function FieldWrapper({ label, required, children, error }) {
    return (
        <div style={{ marginBottom: 18 }}>
            <label style={{ fontWeight: 600, marginBottom: 6, color: "var(--theme-primary)", fontSize: 15 }}>
                {label}
                {required && <span style={{ color: "#d53b3b", marginLeft: 3 }}>*</span>}
            </label>
            {children}
            {error && <div style={{ color: "#d53b3b", fontSize: 13 }}>{error}</div>}
        </div>
    );
}
